import React, {Component} from "react";

import * as MutaSpinnerSvgUtils from "../utils/MutaSpinnerSvgUtils";

import "../../resources/css/spinner.css"
import "../../resources/css/svgimage.css"

export default class MutaSpinner extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: this.props.hasOwnProperty('isLoading') ? this.props['isLoading'] : false
        };
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return nextState.isLoading !== this.state.isLoading;
    }

    render() {

        let spinnerType = this.props['spinnerType'] ? this.props['spinnerType'] : MutaSpinnerSvgUtils.MUTANOIDS;

        let spinnerDivHeight = "0px";
        let spinnerDivWidth = "0px";
        if (this.state.isLoading) {
            spinnerDivHeight = window.screen.height;
            spinnerDivWidth = window.screen.width;
        }

        function RandomSpinnerSvg(props) {
            let spinnerSvgItems = Array(
                MutaSpinnerSvgUtils.getMutaSpinnerSvg1(),
                MutaSpinnerSvgUtils.getMutaSpinnerSvg2(),
                MutaSpinnerSvgUtils.getMutaSpinnerSvg3(),
                MutaSpinnerSvgUtils.getMutaSpinnerSvg4(),
                MutaSpinnerSvgUtils.getMutaSpinnerSvg5(),
                MutaSpinnerSvgUtils.getMutaSpinnerSvg6()
            );
            return spinnerSvgItems[Math.floor(Math.random()*spinnerSvgItems.length)];
        }

        return (
            <div style={{visibility: this.state.isLoading ? 'visible' : 'hidden'}}>
                <div className={'spinnerDiv'} style={{width: spinnerDivWidth, height: spinnerDivHeight}}>
                </div>
                <RandomSpinnerSvg spinnerType={spinnerType}/>
            </div>
        )
    }
}